import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { URL_NAVIGATION_HISTORY } from '../../constants/offline-mode';
import { goBack, reSetNavigationUrl } from '../../hooks/helper';
import '../../sass/customersPage/_back-navigation.scss';

const BackNavigation = (props) => {
    const { onClickCB } = props;
    const history = useHistory();

    useEffect(() => {
        const unlisten = history.listen(({ pathname }) => {
            let urlHistory =
                JSON.parse(localStorage.getItem(URL_NAVIGATION_HISTORY)) || [];

            const index = urlHistory.indexOf(pathname);

            if (index > -1) {
                urlHistory.splice(index, 1);
                reSetNavigationUrl(urlHistory);
            }
        });

        return () => {
            unlisten();
        };
    }, [history]);

    const cb = () => {
        if (onClickCB) {
            onClickCB(goBack);
        } else {
            goBack(history);
        }
    };

    return (
        <button
            className="back-navigation"
            onClick={cb}
        >
            חזור
        </button>
    );
};

export default BackNavigation;